<template>
  <x-page
    :transparent-header="true"
    :enable-header-parallax="true"
    :class="_.page"
    :loading="loading"
  >
    <template v-if="!loading" #header="{ headerParallaxRate, handleBackClick }">
      <div
        :class="_.header"
        :style="{
          backgroundColor:
            headerParallaxRate === 0
              ? 'transparent'
              : `rgba(91, 0, 201, ${headerParallaxRate})`,
        }"
      >
        <!-- 返回 -->
        <x-icon name="back" :class="_.back" @click="handleBackClick" />

        <!-- 标题 -->
        <div :class="[_.title, _._ellipsis]">{{ boxData.boxName }}</div>
      </div>
    </template>

    <template v-if="!loading">
      <!-- 头图 -->
      <div :class="_.headImage">
        <img :src="require('./images/详情页头图.png')" :class="_.image" />
      </div>

      <!-- 布局辅助器 -->
      <div :class="_.layoutHelper"></div>

      <!-- 轮播 -->
      <x-card-swiper
        :class="[_.banner, _[`count${boxData.commodityList.length}`]]"
        :autoplay="boxData.commodityList.length === 1 ? 0 : 1500"
        :duration="500"
        :disabled="boxData.commodityList.length === 1"
        :width="`${pxToRem(234)}rem`"
        :height="`${pxToRem(325)}rem`"
        :spacing="`-${pxToRem(234 / 3)}rem`"
        :scale="1.1"
      >
        <div
          v-for="(item, index) in swiperData"
          :key="item.commodityId"
          v-track="{
            name: '盲盒轮播商品',
            id: 'cl5kwczef0004w6qe575p40sg',
            resource: {
              id: item.commodityId,
              name: item.commodityTitle,
            },
            index: index,
          }"
          :class="_.wrapper"
          @click="handleSwiperGoodsClick(index)"
        >
          <div :class="_.item">
            <div :class="_.container">
              <img :src="item.commodityPic" :class="_.cover" />
              <div :class="[_.name, _._ellipsis]">
                {{ item.commodityTitle }}
              </div>
              <div :class="_.price">
                <div :class="_.label">价值</div>
                <x-price
                  :class="_.value"
                  unit="¥"
                  :value="item.price"
                  :unit-size="14"
                  :value-size="20"
                  color="#FF111C"
                />
              </div>
            </div>
          </div>
        </div>
      </x-card-swiper>

      <!-- 开盒记录 -->
      <div :class="_.record" @click="handleOpenRecordClick">
        <img src="./images/开盒记录按钮.png" :class="_.icon" />
      </div>

      <!-- 详情 -->
      <div :class="_.detail">
        <div :class="_.title">盲盒详情</div>
        <div :class="_.tips">
          本盲盒支持回收，回收价格
          <span :class="_.price">{{ boxData.recoverPrice }}</span>
          元
        </div>
        <!-- 商品列表 -->
        <div :class="_.list">
          <div
            v-for="(item, index) in boxData.commodityList"
            :key="item.commodityId"
            v-track="{
              name: '盲盒列表商品',
              id: 'cl5kwec3t0006w6qegldvdgjy',
              resource: {
                id: item.commodityId,
                name: item.commodityTitle,
              },
              index: index,
            }"
            :class="[_.item, item.sellOut && _.sold]"
            @click="handleGoodsClick(index)"
          >
            <img :src="item.commodityPic" :class="_.cover" />
            <div :class="_.content">
              <div :class="[_.name, _._ellipsis]">
                {{ item.commodityTitle }}
              </div>
              <div :class="_.spec">规格：{{ item.skuDesc }}</div>
              <div :class="_.probability">
                <img :src="require('./images/中奖率.png')" :class="_.icon" />
                中奖率：{{ item.probability }}%
              </div>
              <div :class="_.price">
                <div :class="_.label">市场价</div>
                <x-price
                  :class="_.value"
                  unit="¥"
                  :value="item.price"
                  :unit-size="14"
                  :value-size="20"
                  color="#FF111C"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 规则 -->
      <div :class="_.rule">
        <div :class="_.container">
          <div :class="_.title">盲盒规则</div>
          <div :class="_.content">{{ boxData.rule }}</div>
        </div>
      </div>

      <!-- 操作 -->
      <div :class="_.actions">
        <div
          v-track="{
            name: '盲盒详情-我的盒柜',
            id: 'aca09f7c-268e-4b50-9dc8-671b2ee29408',
          }"
          :class="_.my"
          @click="handleMyClick"
        >
          <van-badge
            :content="
              unopenData ? (unopenData > 99 ? '99+' : unopenData) : undefined
            "
          >
            <x-icon name="box" :class="_.icon" />
          </van-badge>
          <div :class="_.label">我的盒柜</div>
        </div>
        <div
          v-track="{
            name: '试玩一下',
            id: '14974ea8-1fd8-4790-96dd-2460e1a7d0ac',
          }"
          :class="_.trial"
          @click="handleTrialClick"
        >
          试玩一下
        </div>
        <div
          v-track="{
            name: '购买盲盒',
            id: 'c1677230-7695-4ef2-be84-6011d0fdf351',
          }"
          :class="_.buy"
          @click="handleOrderClick"
        >
          ¥ {{ boxData.price }} 购买盲盒
        </div>
      </div>
      <div :class="_.placeholder"></div>

      <!-- 购买 -->
      <van-action-sheet v-model="showPay" :class="_.pay">
        <img
          :src="require('./images/关闭.png')"
          :class="_.close"
          @click="showPay = false"
        />
        <div :class="_.bd">
          <img :src="boxData.boxPic" :class="_.cover" />
          <div :class="_.content">
            <div :class="[_.name, _._ellipsis2]">{{ boxData.boxName }}</div>
            <x-price
              :class="_.price"
              unit="¥"
              :value="boxData.price"
              :unit-size="12"
              :value-size="19"
              color="#FF111C"
            />
          </div>
        </div>
        <div :class="_.ft">
          <div :class="_.agree" @click="payAgree = !payAgree">
            <img
              :src="
                payAgree
                  ? require('./images/选中.png')
                  : require('./images/未选中.png')
              "
              :class="_.icon"
            />
            我已阅读并同意
            <div :class="_.link" @click.stop="handleAgreementClick">
              《多多盲盒购买协议》
            </div>
            。
          </div>
          <div
            v-track="{
              name: '立即购买',
              id: '1e2e07e9-146b-41f4-888f-0502c21837b6',
            }"
            :class="[_.button, !payAgree && _.disabled]"
            @click="handlePayClick"
          >
            立即购买
          </div>
        </div>
      </van-action-sheet>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiBlindBoxBoxDetail,
    apiBlindBoxBoxGetTryCount,
    apiBlindBoxOrderGetUnOpenCount,
    apiBlindBoxOrderTradeOrder,
  } from '@/api'
  import { boxBus } from './bus'
  import { dcb } from '@dcb/jssdk'
  import { defineSwiperOptions } from '@/components'
  import { globalModel } from '@/model'
  import { mapQuery, prepareData, pxToRem, submit, Track } from '@/utils'
  import { navigateTo } from '@/router'
  import { orderBy, wait } from 'vtils'

  export default Vue.extend({
    mixins: [
      mapQuery({
        id: 'id',
      }),
      Track.provideMark(function () {
        return new Promise(resolve => {
          const off = this.$watch(
            () => this.boxData,
            () => {
              if (this.boxData.boxId) {
                off?.()
                resolve({
                  page: '盲盒详情页',
                  id: this.boxData.boxId,
                  name: this.boxData.boxName,
                })
              }
            },
            {
              immediate: true,
            },
          )
        })
      }),
    ],

    data() {
      return {
        loading: true,
        boxData: {},
        swiperIndex: 0,
        swiperOptions: defineSwiperOptions({
          slidesPerView: 'auto',
          centeredSlides: true,
          spaceBetween: 0,
          loop: true,
          initialSlide: 0,
          onChange: swiper => (this.swiperIndex = swiper.realIndex),
        }),
        showPay: false,
        payAgree: false,
        unopenData: 0,
      }
    },

    computed: {
      swiperData() {
        const goodsCount = this.boxData.commodityList.length
        const data =
          goodsCount === 1
            ? [
                this.boxData.commodityList[0],
                this.boxData.commodityList[0],
                this.boxData.commodityList[0],
              ]
            : goodsCount === 2
            ? [...this.boxData.commodityList, ...this.boxData.commodityList]
            : this.boxData.commodityList
        return orderBy(data, [item => item.price], ['desc']).slice(0, 10)
      },
    },

    created() {
      this.prepareData()

      this.$once(
        'hook:beforeDestroy',
        boxBus.on('buy', () => {
          this.showPay = true
        }),
      )
    },

    async activated() {
      this.unopenData = await apiBlindBoxOrderGetUnOpenCount()
    },

    methods: {
      pxToRem: pxToRem,
      async prepareData() {
        const { boxData } = await prepareData({
          boxData: apiBlindBoxBoxDetail({
            id: this.id,
          }),
        })
        this.boxData = boxData
        this.loading = false
      },

      handleSwiperGoodsClick(index) {
        navigateTo('GoodsIndex', {
          id: this.swiperData[index].commodityId,
        })
      },

      handleOpenRecordClick() {
        navigateTo('BoxOpenRecord', {
          id: this.id,
        })
      },

      handleGoodsClick(index) {
        navigateTo('GoodsIndex', {
          id: this.boxData.commodityList[index].commodityId,
        })
      },

      handleMyClick() {
        navigateTo('BoxOrderList')
      },

      handleTrialClick() {
        submit(async $ => {
          $.start()
          const [trialCount] = await Promise.all([
            apiBlindBoxBoxGetTryCount({
              id: this.id,
            }),
            wait(500),
          ])
          if (trialCount === 0) {
            return $.fail('今日试玩次数已用完')
          }
          navigateTo('BoxOpen', {
            id: this.id,
            isTrial: true,
          })
        })
      },

      handleOrderClick() {
        this.showPay = true
      },

      handleAgreementClick() {
        dcb.navigateTo({
          url: 'https://wap.gogpay.cn/8aaa86d67aebce0f017cbf96e8bc003d',
        })
      },

      handlePayClick() {
        submit(async $ => {
          $.start()
          const payParams = await apiBlindBoxOrderTradeOrder({
            id: this.id,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            params: payParams,
          })
          await wait(1000)
          this.showPay = false
          this.$nextTick(() => {
            navigateTo('BoxOpen', {
              id: this.id,
              orderId: payParams.orderId,
            })
          })
        })
      },
    },
  })
</script>

<style lang="scss" module>
  .page {
    background: linear-gradient(360deg, #9c008e 0%, #6500e4 100%);
  }

  .header {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    box-sizing: border-box;
    color: white;

    .back {
      flex-shrink: 0;
      font-size: 16px;

      &:active {
        opacity: 0.8;
      }
    }

    .title {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      font-size: 18px;
      font-weight: bold;
      color: #ffffff;
      line-height: 25px;
      text-align: center;
      max-width: 70%;
    }
  }

  .headImage {
    position: relative;
    font-size: 0;
    z-index: -1;

    .image {
      width: 100%;
    }
  }

  .layoutHelper {
    margin-top: -417px;
  }

  .banner {
    width: 100%;
    height: 325px;
    transform: scale(0.9);

    .wrapper {
      .item {
        position: relative;
        width: 234px;
        height: 325px;

        .container {
          width: 100%;
          height: 100%;
          box-sizing: border-box;
          background-image: url('./images/盲盒卡片.png');
          background-position: center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-top: 38px;

          .cover {
            width: 200px;
            height: 200px;
            border-radius: 8px;
          }

          .name {
            margin-top: 11px;
            width: 80%;
            text-align: center;
            font-size: 18px;
            font-weight: bold;
            color: #925300;
            line-height: 25px;
          }

          .price {
            margin-top: 6px;
            width: 115px;
            height: 28px;
            padding-top: 3px;
            box-sizing: border-box;
            background-image: url('./images/盲盒卡片价格背景.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: baseline;
            justify-content: center;

            .label {
              font-size: 13px;
              color: #a65e00;
              line-height: 18px;
            }

            .value {
              margin-left: 4px;
            }
          }

          &::after {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-image: url('./images/盲盒卡片遮罩.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            opacity: 0;
            transition: opacity ease 300ms;
          }
        }
      }

      &:not(:global(.swipe-item-active)):not(:global(.x1)),
      &:global(.x2):not(:global(.x1)) {
        .item {
          .container {
            &::after {
              opacity: 1;
            }
          }
        }
      }

      &:global(.x3) {
        .item {
          .container {
            &::after {
              opacity: 0 !important;
            }
          }
        }
      }
    }

    &.count1 {
      .wrapper {
        &:not(:global(.swipe-item-active)) {
          display: none;
        }
      }
    }
  }

  .record {
    position: relative;

    .icon {
      position: absolute;
      top: -12px;
      right: 0;
      width: 76px;
      height: 37px;

      &:active {
        filter: contrast(0.98);
      }
    }
  }

  .detail {
    margin: 30px 12px 12px 12px;
    position: relative;
    background: #ae71f5;
    box-shadow: inset 0px 1px 10px 0px rgba(206, 169, 255, 1);
    border-radius: 8px;
    padding: 39px 10px 10px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      position: absolute;
      top: -5.5px;
      left: 50%;
      transform: translateX(-50%);
      width: 188px;
      height: 43px;
      background-image: url('./images/标题背景.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 18px;
      font-weight: bold;
      color: #740100;
      line-height: 25px;
      padding-top: 5px;
      text-align: center;
      box-sizing: border-box;
    }

    .tips {
      background: #7e2fdd;
      border-radius: 1000px;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      padding: 4px 14px;

      .price {
        color: #fdcb7c;
        font-size: 18px;
      }
    }

    .list {
      width: 100%;

      .item {
        margin-top: 10px;
        background: #ffffff;
        border-radius: 8px;
        padding: 12px;
        display: flex;
        align-items: center;

        .cover {
          flex-shrink: 0;
          width: 106px;
          height: 106px;
          background: #ece9e9;
          border-radius: 8px;
        }

        .content {
          flex-grow: 1;
          margin-left: 12px;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          overflow: hidden;

          .name {
            width: 100%;
            font-size: 16px;
            font-weight: bold;
            color: #333333;
            line-height: 22px;
          }

          .spec {
            margin-top: 8px;
            font-size: 14px;
            color: #999999;
            line-height: 20px;
          }

          .probability {
            margin-top: 8px;
            background: #ffeff7;
            border-radius: 100px;
            display: flex;
            align-items: center;
            font-size: 11px;
            font-weight: bold;
            color: #eb38ac;
            line-height: 1;
            padding: 4px 8px;

            .icon {
              width: 11px;
              height: 11px;
              margin-right: 2px;
            }
          }

          .price {
            margin-top: 8px;
            display: flex;
            align-items: center;

            .label {
              font-size: 14px;
              color: #666666;
              line-height: 20px;
            }

            .value {
              margin-left: 4px;
            }
          }
        }

        &.sold {
          position: relative;
          pointer-events: none;

          > * {
            opacity: 0.5;
          }

          &::after {
            content: '';
            position: absolute;
            right: 4px;
            top: 4px;
            width: 44px;
            height: 44px;
            background-image: url('./images/已售罄角标.png');
            background-size: 100% 100%;
            background-repeat: no-repeat;
            background-position: center;
          }
        }
      }
    }
  }

  .rule {
    position: relative;
    padding: 12px;
    background: #ae71f5;
    box-shadow: inset 0px 1px 10px 0px rgba(206, 169, 255, 1);
    border-radius: 8px;
    margin: 30px 12px 12px 12px;

    .container {
      background: #4b0ea8;
      border-radius: 8px;

      .title {
        position: absolute;
        top: -5.5px;
        left: 50%;
        transform: translateX(-50%);
        width: 188px;
        height: 43px;
        background-image: url('./images/标题背景.png');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        font-size: 18px;
        font-weight: bold;
        color: #740100;
        line-height: 25px;
        padding-top: 5px;
        text-align: center;
        box-sizing: border-box;
      }

      .content {
        font-size: 14px;
        color: #dabeff;
        line-height: 22px;
        padding: 37px 12px 12px 12px;
        white-space: pre-line;
      }
    }
  }

  .actions {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    padding: 0 5px 0 12px;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: content-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #770372;

    .my {
      color: #fefefe;
      flex-shrink: 0;
      text-align: center;
      font-size: 0;

      .icon {
        font-size: 20px;
      }

      .label {
        margin-top: 4px;
        font-size: 12px;
        line-height: 1;
      }
    }

    .trial {
      width: 132px;
      height: 50px;
      background-image: url('./images/试玩按钮.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 16px;
      font-weight: bold;
      color: #740100;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .buy {
      width: 170px;
      height: 50px;
      background-image: url('./images/购买按钮.png');
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      font-size: 16px;
      font-weight: bold;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    + .placeholder {
      height: 50px;
    }
  }

  .pay {
    padding: 12px;
    box-sizing: border-box;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .close {
      position: absolute;
      top: 12px;
      right: 12px;
      width: 22px;
      height: 22px;
    }

    .bd {
      padding-top: 10px;
      display: flex;

      .cover {
        flex-shrink: 0;
        width: 100px;
        height: 100px;
        border-radius: 8px;
      }

      .content {
        margin-left: 12px;

        .name {
          padding-right: 16px;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          line-height: 22px;
        }

        .price {
          margin-top: 8px;
        }
      }
    }

    .ft {
      margin-top: 95px;
      margin-bottom: 12px;

      .agree {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #666666;
        line-height: 17px;

        .icon {
          width: 12px;
          height: 12px;
          margin-right: 5px;
        }

        .link {
          color: #2e7eff;
        }
      }

      .button {
        margin-top: 13px;
        width: 100%;
        height: 50px;
        background: linear-gradient(113deg, #ff8541 0%, #ff3c17 100%);
        border-radius: 100px;
        font-size: 16px;
        font-weight: bold;
        color: #ffffff;
        line-height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.disabled {
          pointer-events: none;
          opacity: 0.61;
        }
      }
    }
  }
</style>
